import React, { useEffect, useState } from 'react';

const LoadingScreen = () => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fade out animation after 1.8 seconds
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 1800);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`fixed inset-0 flex items-center justify-center z-50 transition-opacity duration-500 ${
      fadeOut ? 'opacity-0' : 'opacity-100'
    }`}>
      {/* Animated Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-green-50 via-white to-green-100 animate-gradient-shift"></div>
      
      {/* Floating Particles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-primary opacity-30 rounded-full animate-float-slow"></div>
        <div className="absolute top-1/3 right-1/3 w-1 h-1 bg-primary-light opacity-40 rounded-full animate-float-medium"></div>
        <div className="absolute bottom-1/4 left-1/3 w-3 h-3 bg-primary opacity-20 rounded-full animate-float-fast"></div>
        <div className="absolute bottom-1/3 right-1/4 w-1.5 h-1.5 bg-primary-light opacity-35 rounded-full animate-float-slow"></div>
      </div>

      <div className="relative text-center z-10">
        {/* Logo with Elegant Animation */}
        <div className="mb-8 transform transition-all duration-1000 animate-scale-in">
          <img 
            src="/img/logo.png" 
            alt="Olive Fulda" 
            className="h-20 mx-auto filter drop-shadow-lg animate-gentle-pulse"
          />
        </div>
        
        {/* Elegant Loading Animation - Rotating Olive Branch */}
        <div className="flex justify-center mb-8">
          <div className="relative">
            {/* Outer Ring */}
            <div className="w-16 h-16 border-2 border-primary opacity-20 rounded-full animate-spin-slow"></div>
            {/* Inner Rotating Element */}
            <div className="absolute inset-2 w-12 h-12 border-t-2 border-r-2 border-primary rounded-full animate-spin"></div>
            {/* Center Dot */}
            <div className="absolute inset-6 w-4 h-4 bg-primary rounded-full animate-pulse"></div>
          </div>
        </div>
        
        {/* Welcome Message with Fade-in Animation */}
        <div className="animate-fade-in-up">
          <h2 className="text-2xl md:text-3xl font-playfair font-semibold text-gray-800 mb-2">
            Willkommen bei Olive Fulda
          </h2>
          <p className="text-lg text-gray-600 font-light tracking-wide">
            Authentische mediterrane Küche
          </p>
        </div>
        
        {/* Loading Progress Indicator */}
        <div className="mt-8 w-48 mx-auto">
          <div className="h-1 bg-gray-200 rounded-full overflow-hidden">
            <div className="h-full bg-gradient-to-r from-primary to-primary-light rounded-full animate-loading-bar"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;